import React, { useEffect, useState } from 'react';
import { CalendarClock } from 'lucide-react';
import { api, eur } from '../api';
import { Card, SectionTitle } from '../ui';

const MODE = { monthly: 'Mensile', annual: 'Annuale' };
const day = (s) => (s ? new Date(s).toLocaleDateString('it-IT', { day: '2-digit', month: 'long', year: 'numeric' }) : '—');

export default function SubscriptionsCard() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get('/wallet/subscriptions').then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  return (
    <Card className="mb-8" data-testid="subscriptions-card">
      <div className="px-6 pt-6 flex items-center gap-2"><CalendarClock size={16} className="text-[#D4AF37]" /><SectionTitle>Canoni attivi</SectionTitle></div>
      {rows.length === 0 ? <p className="px-6 pb-6 text-sm text-[#7A7F87]" data-testid="subscriptions-empty">Nessun canone mensile o annuale attivo.</p> : (
        <div className="divide-y divide-[#1F242C]">
          {rows.map((s) => (
            <div key={s.key} className="px-6 py-4 grid sm:grid-cols-[1fr_110px_120px_200px] gap-x-4 gap-y-1 items-center text-sm" data-testid={`subscription-row-${s.key}`}>
              <span className="text-[#E5E5E5]">{s.label}</span>
              <span className="text-[#8A8F97]">{MODE[s.mode] || s.mode}</span>
              <span className="font-mono text-[#F2F2F2]">{eur(s.cents)}</span>
              {s.active
                ? <span className="text-[#8A8F97]" data-testid={`subscription-renewal-${s.key}`}>Rinnovo il {day(s.paid_until)}</span>
                : <span className="text-[#E37A72]" data-testid={`subscription-suspended-${s.key}`}>Sospeso: ricarica il plafond</span>}
            </div>
          ))}
          <p className="px-6 py-4 text-xs text-[#5A5F67]">I canoni si rinnovano in automatico dal plafond alla data indicata. Se il saldo non basta il servizio viene sospeso e ricevi un'email.</p>
        </div>
      )}
    </Card>
  );
}
